import api from "./api";

// Opens the mission's giving page in a NEW tab so the app stays open underneath —
// closing the give tab (or the native "Done"/back on an installed PWA) returns instantly.
export function openGive(url) {
  if (!url) return false;
  api.post("/give-clicks").catch(() => {});
  window.open(url, "_blank", "noopener,noreferrer");
  return true;
}
